import React, { useState } from "react";
import * as XLSX from "xlsx";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import { TVisitor } from "apis/visitors/type";
import { useRecoilValue } from "recoil";
import { util } from "recoil/recoilState";
import { translate } from "./translate";

const BtnContainer = styled.div`
    border-radius: 8px;
    background-color: ${theme.primary50};
    color: ${theme.primary500};
    font-weight: 700;
    padding: 12px 20px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
        background-color: ${theme.primary500};
        color: white;
    }
`;

type TVisitorExcel = {
    이름?: string;
    안내채널?: string;
    전화번호?: string;
    이메일?: string;
};

const ExcelUploaderBtn = ({ onChange }: { onChange?: (value: TVisitor[]) => void }) => {
    const [file, setFile] = useState<File | null>(null);
    const { language } = useRecoilValue(util);

    // 파일 선택 시 실행되는 함수
    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (selectedFile) {
            // 파일 읽기
            const fileReader = new FileReader();
            fileReader.onload = (event) => {
                const data = new Uint8Array(event.target?.result as ArrayBuffer);
                // xlsx 파일로 변환
                const workbook = XLSX.read(data, { type: "array" });
                // 첫 번째 시트 가져오기
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                // 시트를 JSON으로 변환
                const jsonData: TVisitorExcel[] = XLSX.utils.sheet_to_json(sheet);
                // 추출된 데이터 처리

                const res: TVisitor[] = jsonData.map((item) => {
                    return {
                        name: item.이름 ? item.이름 : undefined,
                        guideChannel: item.안내채널 === "KAKAO" ? "KAKAO" : "EMAIL",
                        phoneNumber: item.전화번호 !== null ? `${item.전화번호}`.replaceAll("-", "") : null,
                        email: item.이메일 !== null ? `${item.이메일}` : null,
                    };
                });

                onChange?.(res);
                e.target.value = "";
            };

            fileReader.readAsArrayBuffer(selectedFile);
            // 선택된 파일 저장
            setFile(selectedFile);
        }
    };

    // 사용자 지정 스타일을 적용한 파일 업로드 영역
    return (
        <BtnContainer>
            <label style={{ cursor: "pointer" }}>
                <div>{translate["방문자 등록 Excel 업로드"][language]}</div>
                <input type="file" accept=".xlsx, .xls" onChange={handleFileChange} style={{ display: "none" }} />
            </label>
        </BtnContainer>
    );
};

export default ExcelUploaderBtn;
